import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { WorksPageProps } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { loadWorks } from '@/lib/content'
import SiteHeader from '@/components/landing/site-header'
import SiteFooter from '@/components/landing/site-footer'
import WorksArchive from '@/components/landing/works-archive'
import LiveWidget from '@/components/landing/live-widget'

const WorksPage: FC<Partial<WorksPageProps>> = ({ works = [] }): ReactNode => {
    return (
        <Layout header={<SiteHeader page='works' />} footer={<SiteFooter />}>
            <Seo
                title='Works'
                description='天満ニア（AMAMA NIA）の活動記録アーカイブ。企業案件、公式ゲーム・IP、大規模コラボ、歌唱・ボイス、メディア、イベントの実績を検索できます。'
            />

            <WorksArchive works={works} />
            <LiveWidget initial={null} />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<WorksPageProps> = async () => {
    const works = await loadWorks()

    return {
        props: { works },
        revalidate: 60
    }
}

export default WorksPage
